(function () {
  'use strict';

  class VisualProductResults {
    constructor({ grid, count, source, idPrefix }) {
      this.grid = grid;
      this.count = count;
      this.source = source;
      this.idPrefix = idPrefix || 'VisualProducts';
      this.bind();
    }

    bind() {
      this.grid.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-visual-product-tab]');
        if (tab) this.activateProductType(tab.dataset.visualProductTab);
      });

      this.grid.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-visual-product-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.grid.querySelectorAll('[data-visual-product-tab]')];
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextTab = tabs[(tabs.indexOf(tab) + direction + tabs.length) % tabs.length];
        this.activateProductType(nextTab.dataset.visualProductTab);
        nextTab.focus();
      });
    }

    setSource(source) {
      this.source = source;
    }

    clear() {
      this.grid.innerHTML = '';
      if (this.count) this.count.textContent = '';
    }

    render(products, groups, preferredType) {
      const productList = Array.isArray(products) ? products : [];
      if (!productList.length) {
        this.clear();
        return 0;
      }

      const wallMurals = Array.isArray(groups?.wallMurals)
        ? groups.wallMurals
        : productList.filter((product) => product.productType === 'Wall Mural');
      const wallpapers = Array.isArray(groups?.wallpapers)
        ? groups.wallpapers
        : productList.filter((product) => product.productType === 'Wallpaper');
      const orderedGroups = preferredType === 'Wall Mural'
        ? [['wall-murals', 'Wall Murals', wallMurals], ['wallpapers', 'Wallpapers', wallpapers]]
        : [['wallpapers', 'Wallpapers', wallpapers], ['wall-murals', 'Wall Murals', wallMurals]];
      const availableGroups = orderedGroups.filter(([, , items]) => Array.isArray(items) && items.length);

      if (!availableGroups.length) {
        this.clear();
        return 0;
      }

      const total = availableGroups.reduce((sum, [, , items]) => sum + items.length, 0);
      if (this.count) this.count.textContent = `${total} ${total === 1 ? 'product' : 'products'}`;
      const activeType = availableGroups[0][0];
      const tabs = availableGroups.map(([type, label, items], index) => {
        const tabId = `${this.idPrefix}Tab-${type}`;
        const panelId = `${this.idPrefix}Panel-${type}`;
        return '<button class="visual-search-type-tab' + (index === 0 ? ' is-active' : '') + '" type="button" role="tab"' +
          ' id="' + tabId + '" aria-controls="' + panelId + '" aria-selected="' + (index === 0) + '"' +
          ' tabindex="' + (index === 0 ? '0' : '-1') + '" data-visual-product-tab="' + type + '">' +
          '<span>' + label + '</span><strong>' + items.length + '</strong></button>';
      }).join('');
      const panels = availableGroups.map(([type, label, items]) => {
        const tabId = `${this.idPrefix}Tab-${type}`;
        const panelId = `${this.idPrefix}Panel-${type}`;
        return '<section class="visual-search-product-panel" role="tabpanel" id="' + panelId + '"' +
          ' aria-labelledby="' + tabId + '" data-visual-product-panel="' + type + '"' + (type === activeType ? '' : ' hidden') + '>' +
          '<h4 class="visually-hidden">' + label + '</h4>' +
          '<div class="visual-search-results__grid">' + items.map((product) => this.productCard(product)).join('') + '</div>' +
          '</section>';
      }).join('');

      this.grid.innerHTML = '<div class="visual-search-type-tabs" role="tablist" aria-label="Product type">' + tabs + '</div>' + panels;
      return total;
    }

    activateProductType(type) {
      this.grid.querySelectorAll('[data-visual-product-tab]').forEach((tab) => {
        const active = tab.dataset.visualProductTab === type;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.grid.querySelectorAll('[data-visual-product-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.visualProductPanel !== type;
      });
    }

    productCard(product) {
      const title = this.escape(product.title || 'Wallpaper design');
      const rawImage = String(product.image || '');
      if (!rawImage || !product.url) return '';
      const imageUrl = rawImage + (rawImage.includes('?') ? '&' : '?') + 'width=640';
      const attributedUrl = window.MurallsFunnel?.attributedUrl(product.url, this.source) || product.url;
      const card = '<a class="visual-search-card" href="' + this.escape(attributedUrl) + '" aria-label="View ' + title + '"' +
        ' data-funnel-product-link data-funnel-source="' + this.escape(this.source) + '"' +
        ' data-funnel-product-handle="' + this.escape(product.handle) + '">' +
        '<div class="visual-search-card__image"><img src="' + this.escape(imageUrl) + '" alt="' + title + '" loading="lazy"></div>' +
        '<span class="visual-search-card__open" aria-hidden="true">↗</span></a>';
      if (this.source !== 'find_similar') return card;
      return '<article class="similar-result-card" data-similar-handle="' + this.escape(product.handle) + '">' +
        card + '<p class="similar-result-card__title">' + title + '</p></article>';
    }

    escape(value) {
      return String(value || '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      })[character]);
    }
  }

  window.MurallsVisualProductResults = VisualProductResults;
})();
